import Permissions from "../../views/Permissions";

const PermissionsPage = () => {
  return <Permissions />;
};

export default PermissionsPage;
